export default function Pagination({ current, total, onPageChange }) {
  return (
    <div className="flex gap-2 justify-center mt-6">
      {[...Array(total)].map((_, i) => (
        <button
          key={i}
          onClick={() => onPageChange(i + 1)}
          className={`px-4 py-2 rounded ${
            current === i + 1
              ? "text-white bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold hover:shadow-lg hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300"
              : "bg-slate-700 text-white rounded-full "
          }`}
        >
          {i + 1}
        </button>
      ))}
    </div>
  );
}